export default __webpack_public_path__ + "static/media/right-img-desktop.9aefdb88.jpg";